import { createApp } from 'vue'
import AppTeam from './AppTeam.vue'
import AppAbteilungen from './AppAbteilungen.vue'
import AppService from './AppService.vue'

const domAppTeam = document.getElementById('appTeam');
const domAppAbteilungen = document.getElementById('appAbteilungen');
const domAppService = document.getElementById('appService');

if(domAppTeam) {
  createApp(AppTeam).mount("#appTeam");
}

if(domAppAbteilungen) {
  const mountElAbteilungen = document.querySelector("#appAbteilungen");
  createApp(AppAbteilungen, { ...mountElAbteilungen.dataset }).mount("#appAbteilungen");
}

if(domAppService) {
  createApp(AppService).mount("#appService");
}
